export const MINIMUM_SEARCH_CHARACTERS = 2

export const WEEKS_IN_YEAR = 52.1429

export const TOTAL_FEE = 0.003
export const LP_HOLDERS_FEE = 0.0025
export const TREASURY_FEE = 0.0005
export const BUYBACK_FEE = 0.

export const PCS_BITGERT_START = 1654207200 // June 03, 2022
export const PCS_XDC_START = 1670108400 // Dec 04, 2022
export const PCS_CORE_START = 1675828800 // Feb 08, 2023
export const ONE_DAY_UNIX = 86400 // 24h * 60m * 60s
export const ONE_HOUR_SECONDS = 3600

export const ITEMS_PER_INFO_TABLE_PAGE = 10
